export default __webpack_public_path__ + "static/media/study_btn.a82f42e1.png";